import * as OrderActions from '../Constants/index';

export const setOrders = (payload) => {
    return {
        type:OrderActions.SET_ORDERS,
        data:payload
    }
}

export const setLastClickedElement = (payload) => {
    return {
        type:OrderActions.SET_LAST_CLICKED_ELEMENT,
        data:payload
    }
}

export const clearState = (payload) => {
    return {
        type:OrderActions.CLEAR_STATE,
        data:payload
    }
}
